import {
  styled,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { chromeYellow, kiwiGreen } from '../../../../../../../../../../../utils/colors';

const StyledTypography = styled(Typography)({
  margin: 0,
  fontSize: 10,
  borderRadius: 4,
  lineHeight: '16px',
  padding: '2px 8px',
  fontWeight: 700,
  width: 'max-content',
  textTransform: 'uppercase',
  display: 'flex',
  gap: 4,
  alignItems: 'center',

  backgroundColor: chromeYellow[500],
  color: 'white',

  '&.finished': {
    backgroundColor: kiwiGreen[500],
    color: 'white',
  },

});

export default function RunResultTag(props: { finished: boolean }) {
  const { finished } = props;
  const { t } = useTranslation('session');
  return (
    <StyledTypography className={finished ? 'finished' : undefined}>
      {t(`details.decision-tree-runs.${finished ? 'finished' : 'interrupted'}`)}
    </StyledTypography>
  );
}
